<template>
  <!-- Start -->
  <section class="relative bg-indigo-600/5">
      <div class="container-fluid relative">
          <div class="grid grid-cols-1">
              <div class="flex flex-col min-h-screen justify-center md:px-10 py-10 px-4">
                  <div class="text-center">
                      <router-link to="/">
                        <img src="@assets/images/logo/logo.svg" class="mx-auto" alt="Logo" />
                      </router-link>
                  </div>
                  <div class="title-heading text-center my-auto">
                      <img src="@assets/images/error.png" class="mx-auto" alt="">
                      <h1 class="mt-3 mb-6 md:text-5xl text-3xl font-bold">Page Not Found?</h1>
                      <p class="text-slate-400">Whoops, this is embarassing. <br> Looks like the page you were looking for wasn't found.</p>

                      <div class="mt-4">
                          <router-link to="/" class="btn bg-theme-orange-01 hover:bg-theme-orange-01/75 border-theme-orange-01 hover:border-theme-orange-01/75 text-white rounded-md">Back to Home</router-link>
                      </div>
                  </div>
                  <div class="text-center">
                      <p class="mb-0 text-slate-400">© {{ new Date().getFullYear() }} Liveet. All rights reserved.</p>
                  </div>
              </div>
          </div><!--end grid-->
      </div><!--end container-->
  </section><!--end section-->
  <!-- End -->
</template>

<script>
export default {
  page: {
    title: '404',
    meta: [{ name: 'description', content: '404 Page Not Found' }],
  },
}
</script>
